/**
 * Module dependencies.
 */

import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useQuery } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Export `NoteSearchResult` type.
 */

export type NoteSearchResult = {
  id: string;
  name: string;
  path: string[];
  snippet: string;
};

/**
 * Export `useNotesSearch` — full-text search over the user's notes. Only runs
 * once the query is at least 2 characters.
 */

export function useNotesSearch(query: string) {
  const client = useRequestProvider();
  const term = query.trim();

  return useQuery<NoteSearchResult[]>(['notesSearch', term], {
    enabled: term.length >= 2,
    keepPreviousData: true,
    queryFn: async () =>
      client
        .get(resolveAppUrl('appsNotesSearch'), { params: { q: term } })
        .then(({ data }: { data: any }) => data ?? [])
  });
}
